export const TOURNAMENT_CREATED = "Tournaments Created";
export const MATCH_CREATED = "Matches created";
export const TEAM_CREATED = "Team Created";
export const POINTS_PAGE_ACCESS = "PT page accessed";
export const PT_DOWNLOADED = "PT Downloaded";
export const RESPONSES_ADDED = "Team registered";
export const TEAM_APPROVED  = 'Team Approved';
export const APP_INSTALL ="App Install";